const hasValue = data =>
  (data && typeof data == 'object')
    ? Boolean(!data.isInactive && (data.value || data.actualValue || data.comment))
    : Boolean(data);

export default hasValue;